<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderClientSlim :project="project" />
      </slot>
    </template>

    <AttachmentsPrintGrid
      :attachments="project.earthingSubstructureAttachments"
      fieldName="earthingSubstructureAttachments"
      :maxImages="4"
    />

    <div class="content-box">
      <div class="two-column-grid">
        <div>{{ $t('railsEarthed') }}</div>
        <div>{{ $t(project.enpalReport.railsEarthed) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.brickAndSubstructureOptionalAttachments"
      fieldName="optionalNotesAndAttachments"
      :maxImages="4"
    >
      <div class="two-column-grid">
        <div>{{ $t('optional_notes_description') }}</div>
        <div>{{ project.enpalReport.brickAndUkOptionalNotes }}</div>
      </div>
    </AttachmentsPrintGrid>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderClientSlim from '@/components/Print/PrintHeaderClientSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'MeasurementPrintPage1',
  components: {
    PrintPage,
    PrintHeaderClientSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
